import {
    GET_ALL_AGE_GROUP_BEGIN,
    GET_ALL_AGE_GROUP_SUCCESS,
    GET_ALL_AGE_GROUP_ERROR,
    ADD_AGE_GROUP_BEGIN,
    ADD_AGE_GROUP_SUCCESS,
    ADD_AGE_GROUP_ERROR,
    GET_AGE_GROUP_BEGIN,
    GET_AGE_GROUP_ERROR,
    GET_AGE_GROUP_SUCCESS,
    UPDATE_AGE_GROUP_BEGIN,
    UPDATE_AGE_GROUP_SUCCESS,
    UPDATE_AGE_GROUP_ERROR,
    DELETE_AGE_GROUP_BEGIN,
    DELETE_AGE_GROUP_SUCCESS,
    DELETE_AGE_GROUP_ERROR,
  } from "./constants";
  
  const initState = {
    list: [],
    loading: false,
    error: null,
  };
  
  const AgeGroupReducer = (state = initState, action) => {
    const { type, data, error } = action;
    switch (type) {
      case GET_ALL_AGE_GROUP_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case GET_ALL_AGE_GROUP_SUCCESS:
        return {
          ...state,
          list: data,
          loading: false,
        };
      case GET_ALL_AGE_GROUP_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case ADD_AGE_GROUP_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case ADD_AGE_GROUP_SUCCESS:
        return {
          ...state,
          loading: false,
          list: [...state.list, data],
        };
      case ADD_AGE_GROUP_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case GET_AGE_GROUP_BEGIN:
        return {
          ...state,
          loading: true,
          AgeGroupData: "",
        };
      case GET_AGE_GROUP_SUCCESS:
        return {
          ...state,
          loading: false,
          AgeGroupData: data,
        };
      case GET_AGE_GROUP_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case UPDATE_AGE_GROUP_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case UPDATE_AGE_GROUP_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.map((ele) => {
            if (ele.id === data.id) {
              return { ...data };
            } else return ele;
          }),
        };
      case UPDATE_AGE_GROUP_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case DELETE_AGE_GROUP_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case DELETE_AGE_GROUP_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.filter((ele) => ele.id !== data.id),
        };
      case DELETE_AGE_GROUP_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      default:
        return state;
    }
  };
  
  export default AgeGroupReducer;
  